import React, {useContext, useEffect} from 'react';
import {Space} from 'antd';
import {observer} from "mobx-react";
import {CardStyled} from "../../../components/styled/card.styled";
import {StoreContext} from "../../../store.context";
import * as Role from "../../../modules/role";
import {Translate} from "../../../components/util/translation.util";
import {TranslationDomainEnum} from "../../../types/enums";
import {Helmet} from "react-helmet-async";

export const List: React.FC = observer(() => {
    const { appStore: {
        moduleStore: {
            roleStore: {
                setTableFilterData,
                list
            }
        },
            translate
    } } = useContext(StoreContext);

    const translationDomain = TranslationDomainEnum.USER_ADMINISTRATION;
    const title = translate('role.title.roles', {}, translationDomain);

    const onSubmit = (values: any) => {
        setTableFilterData && setTableFilterData(values);
        list();
    };

    useEffect(() => {
        list();
    }, [list])

    return (
        <React.Fragment>
            <Helmet>
                <title>{`CL BO - ${title}`}</title>
            </Helmet>
            <Space direction="vertical" size="small" style={{ display: 'flex' }}>
                <Role.FilterForm onSubmit={onSubmit} />

                <CardStyled title={<Translate message={`global.title.search_results`} />}>
                    <Role.FilterTable />
                </CardStyled>
            </Space>
        </React.Fragment>
    )
})